import { createCodedError } from '~/common/errors/CodedError';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { ServiceRequestConfig } from '~/services/createService';
import { scribyl } from '~/services/serviceInstances';

type CreateSharepointConfigurationRequest = {
  tenantId: string;
  sharepointUrl: string;
  id?: string;
};

export async function createSharepointConfiguration(
  request: CreateSharepointConfigurationRequest,
  options: ServiceRequestConfig = {},
): Promise<void> {
  try {
    if (request.id) {
      await scribyl.patch(
        `/integration-config/${request.id}`,
        { tenantId: request.tenantId, sharepointUrl: request.sharepointUrl },
        options,
      );
    } else {
      await scribyl.post('/integration-config', request, options);
    }
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors?.[0];
      throw createCodedError({
        message: errorResponse?.detail ?? errorResponse?.title,
        statusCode: errorResponse?.status,
        title: errorResponse?.title,
      });
    }
    throw error;
  }
}
